import { useQuery } from 'modules/core/hooks/useQuery'
import { HeadcountCountPendingRequestsDocument } from 'generated/resources/graphql'

interface UseHasPendingRequestsParams {
  periodId: string
  planningId?: string
}

const useHasPendingRequests = ({ periodId, planningId }: UseHasPendingRequestsParams): boolean => {
  const { data } = useQuery(HeadcountCountPendingRequestsDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      planningPeriodId: periodId,
      planningPlanningIds: planningId ? [planningId] : undefined,
    },
  })

  const totalCount = data?.planning?.requestsConnection?.totalCount ?? 0

  if (data === undefined) {
    return true
  }

  return totalCount > 0
}

export default useHasPendingRequests
